// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1jfi7","row":"ProcedureTreatmentSummary_row__2cyPt"};